import { useRef } from "react";
import { AdministrateTable } from "../../components/AdministrateTable";
import { Toolbar } from "../../../components/Toolbar";
import { DESTROY, UPDATE, makeColumns } from "../../utils";
import { XifinAuthConfigActionCell } from "../../labs/components/XifinAuthConfigActionCell";
import { CreateXifinAuthConfigModal } from "../components/CreateXifinAuthConfigModal";

const useColumns = makeColumns((labId) => [
  {
    id: "id",
    accessor: "id",
    Header: "ID",
    maxWidth: 15,
  },
  {
    id: "status",
    accessor: "status",
    Header: "Status",
  },
  {
    id: "substatus",
    accessor: "substatus",
    Header: "Substatus",
  },
  {
    id: "auth_number",
    accessor: "authNumber",
    Header: "Auth Number",
  },
  {
    id: "actions",
    Header: "Actions",
    disableFilters: true,
    disableSortBy: true,
    Cell: ({ row }) => <XifinAuthConfigActionCell row={row} />,
  },
]);

export const XifinAuthConfigTab = ({ lab, labId }) => {
  const tableRef = useRef();
  const extraParams = { labId: labId };
  const columns = useColumns(labId);

  const onCreate = (newXifinAuthConfig) => {
    const { refresh, setMessage } = tableRef.current;

    setMessage(`Created new Xifin Auth Config override`);
    refresh();
  };

  return (
    <>
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <CreateXifinAuthConfigModal color="primary" labId={labId} onCreate={onCreate} />
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={`/admin/xifin_auth_number_overrides.json`}
        resourceName={"xifin_auth_number_overrides"}
        extraParams={extraParams}
        permissions={[UPDATE, DESTROY]}
        columns={columns}
        ref={tableRef}
      />
    </>
  );
};
